import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/AppRoutes";
import WhatsAppFAB from "./components/ui/WhatsappFab";
import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <>
      <AppRoutes />
      <ScrollToTop />
      <Toaster position="top-center" reverseOrder={false} />
      <WhatsAppFAB />
    </>
  );
}

export default App;
